import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { useAppStore } from '../../stores';

const InsuredPeriodStartInput: InputWithSource = ({ input }) => {
    const { actionStore } = useAppStore();

    return (
        <GenericSelect
            label={input.name}
            input={input}
            onChange={() => actionStore.changeInsuredPeriodStart(input.worksheetId, input.nodeId)}
        />
    );
};

InsuredPeriodStartInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(InsuredPeriodStartInput);
